import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CommonService {
  selectedLanguage: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>('en');
}
